import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ChartFilter} from './frequency-view-chart-filters-container/frequency-view-chart-filters-container.component';

@Injectable({
  providedIn: 'root'
})
export class FrequencyViewChartFilterService {
  private readonly chartFiltersSubject = new BehaviorSubject<ChartFilter[]>([]);

  getChartFilters(): Observable<ChartFilter[]> {
    return this.chartFiltersSubject.asObservable();
  }

  getChartFilter(filterId: string): ChartFilter {
    return this.chartFiltersSubject.getValue().find(filter => filter.id === filterId);
  }

  upsertChartFilter(chartFilter: ChartFilter): void {
    const headerFilters = this.chartFiltersSubject.getValue();
    const index = headerFilters.findIndex(existingHeaderFilter => existingHeaderFilter.id === chartFilter.id);

    if (index > -1) {
      headerFilters.splice(index, 1);
      headerFilters.splice(index, 0, chartFilter);
    } else {
      headerFilters.push(chartFilter);
    }

    this.chartFiltersSubject.next(headerFilters.slice());
  }
}
